export { default as amountWithCurrency } from './amount_with_currency';
export { default as cents } from './cents';
export { default as decrementId } from './decrement_id';
export { default as deleteAllCookies } from './delete_all_cookies';
export { default as depixify } from './depixify';
export { default as dollar } from './dollar';
export { default as formatComment } from './format_comment';
export { default as formatNumber } from './format_number';
export { default as formattedRoundNumber } from './formatted_round_number';
export { default as getCookieValue } from './get_cookie_value';
export { default as getUserMedia } from './get_user_media';
export { default as incrementId } from './increment_id';
export { default as isBlank } from './is_blank';
export { default as isPresent } from './is_present';
export { default as isValidEmail } from './is_valid_email';
export { default as kFormatter } from './k_formatter';
export { default as pixify } from './pixify';
export { default as removeArticleFromText } from './remove_article_from_text';
export { default as removeCookie } from './remove_cookie';
export { default as setCookieValue } from './set_cookie_value';
export { default as setInputCaret } from './set_input_caret';
export { default as toCamelCase } from './to_camel_case';
export { default as sentryInitializer } from './sentry_initializer';
export { default as detectBrowserSpeed } from './detect_browser_speed';
export { default as createUuid } from './create_uuid';
export { default as isTruthy } from './is_truthy';
export { default as formatFilterTag } from './format_filter_tag';
export { default as displayTargetTextCorrectedForLanguage } from './display_target_text_corrected_for_language';
export { default as getYoutubeEmbedUrl } from './get_youtube_embed_url';
export { default as capitalizeFirstLetter } from './capitalize_first_letter';
export { default as loadCss } from './load_css';
export { default as loadScript } from './load_script';
export { lightenColor } from './lighten_color';
export { default as normalizeCharacters } from './normalize_characters';
export { default as stripHtmlTags } from './strip_html_tags';
export { default as sleep } from './sleep';
export { bootstrapPosthogConfig, captureLandingCampaignParams, capturePosthogEvent, getPosthogSessionId, initPosthog, setPosthogTrackingEnabled, shouldTrackWebPosthog, syncPosthogUser } from './posthog';
export { buildSharedEventProperties, buildWebPosthogEventProperties, isFrontendOnlyEvent } from './event_properties';
export { default as withoutDigits } from './string_utils';
export { compareSubmittedValueWithSolution, sameWithoutCaseAccentsAndPunctuation, underlineWronglyPositionedCharacters } from './exercise_input_comparison';
export { getMessageFromError } from './error_utils';
export { safeParseJson } from './json_utils';
export { niceJoin } from './nice_join';
export {
  referrerOptionGridRowCount,
  referrerOptionButtonHeightForRows,
  referrerOptionButtonHeightForOptions,
} from './referrer_option_grid';
export { default as truncateAtWordBoundary } from './truncate_at_word_boundary';
export { deckCardListExercise, deckCardListText, deckCardListTypeName } from './deck_card_list';

export { default as emailTypoSuggestion } from './email_typo_suggestion';
